module.exports = __webpack_public_path__ + "static/media/binnen_woonkamer_oost.040f052b.jpg";